const React = require('react');

export default class TabFromItem extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {

    };
  }

  render() {
    const {
      type,
      a
    } = this.props; //这里就上层的值
    console.log(a);//就是进来的a
    return (
        <div>
            {
              type === "Null" && (
                <div style={{paddingTop:'20px'}}>
                    <div id="JobsEditor10000" className="editorGroup" style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                        <label for="jobsinput10000" className="fieldGroupLabel" style={{paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap',marginBottom: '0px'}}>返回值：  </label>
                        <div style={{position: 'relative'}}>
                            <input type="text" spellcheck="false" placeholder="String" id="jobsinput10000" disabled className="form-control" style={{padding: '2px', height: '22px', width: '180px', fontSize: '12px'}}/>
                        </div>
                    </div>
                    <div id="JobsEditor10001" className="editorGroup" style={{display: 'flex', flexDirection: 'row', alignItems: 'center',paddingTop:'5px'}}>
                        <label for="jobsinput10001" className="fieldGroupLabel" style={{paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap',marginBottom: '0px'}}>参&#12288;数：</label>
                        <div style={{position: 'relative'}}>
                            <input type="text" spellcheck="false" placeholder="该Job无需调用参数" id="jobsinput10001" className="form-control" style={{padding: '2px', height: '22px', width: '180px', fontSize: '12px'}}/>
                        </div>
                    </div>
                </div>
              )
            }
            {
              type === "String" && (
                <div style={{paddingTop:'20px'}}>
                    <h6 style={{textAlign:'center',fontWeight:'bolder'}}>{a.jobDescription}</h6>
                    <div id="JobsEditor10000" className="editorGroup" style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                        <label for="jobsinput10000" className="fieldGroupLabel" style={{paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap',marginBottom: '0px'}}>返回值：  </label>
                        <div style={{position: 'relative'}}>
                            <input type="text" spellcheck="false" placeholder={a.returnDescription} id="jobsinput10000" disabled className="form-control" style={{padding: '2px', height: '22px', width: '180px', fontSize: '12px'}}/>
                        </div>
                    </div>
                    <div id="JobsEditor10001" className="editorGroup" style={{display: 'flex', flexDirection: 'row', alignItems: 'center',paddingTop:'5px'}}>
                        <label for="jobsinput10001" className="fieldGroupLabel" style={{paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap',marginBottom: '0px'}}>参&#12288;数：</label>
                        <div style={{position: 'relative'}}>
                            <input type="text" spellcheck="false" placeholder={a.paramDescription} id="jobsinput10001" className="form-control" style={{padding: '2px', height: '22px', width: '180px', fontSize: '12px'}}/>
                        </div>
                    </div>
                </div>
              )
            }
            {
              type === "String2" && (
                <div style={{paddingTop:'20px'}}>
                    <h6 style={{textAlign:'center',fontWeight:'bolder'}}>{a.jobDescription}</h6>
                    <div id="JobsEditor10000" className="editorGroup" style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                        <label for="jobsinput10000" className="fieldGroupLabel" style={{paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap',marginBottom: '0px'}}>返回值：  </label>
                        <div style={{position: 'relative'}}>
                            <input type="text" spellcheck="false" placeholder={a.returnDescription} id="jobsinput10000" disabled className="form-control" style={{padding: '2px', height: '22px', width: '180px', fontSize: '12px'}}/>
                        </div>
                    </div>
                    <div id="JobsEditor10001" className="editorGroup" style={{display: 'flex', flexDirection: 'row', alignItems: 'center',paddingTop:'5px'}}>
                        <label for="jobsinput10001" className="fieldGroupLabel" style={{paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap',marginBottom: '0px'}}>参&#12288;数：</label>
                        <div style={{position: 'relative'}}>
                            <input type="text" readonly="readonly" spellcheck="false" placeholder={a.paramDescription} id="jobsinput10001" className="form-control" style={{padding: '2px', height: '22px', width: '180px', fontSize: '12px'}}/>
                        </div>
                    </div>
                </div>
              )
            }
             {
              type === "ReClipboard" && (
                <div style={{paddingTop:'20px'}}>
                    <h6 style={{textAlign:'center',fontWeight:'bolder'}}>{a.jobDescription}</h6>
                    <div id="JobsEditor10000" className="editorGroup" style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                        <label for="jobsinput10000" className="fieldGroupLabel" style={{paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap',marginBottom: '0px'}}>返回值：  </label>
                        <div style={{position: 'relative'}}>
                            <input type="text" spellcheck="false" placeholder={a.returnDescription} id="jobsinput10000" className="form-control" style={{padding: '2px', height: '22px', width: '180px', fontSize: '12px'}}/>
                        </div>
                    </div>
                    <div id="JobsEditor10001" className="editorGroup" style={{display: 'flex', flexDirection: 'row', alignItems: 'center',paddingTop:'5px'}}>
                        <label for="jobsinput10001" className="fieldGroupLabel" style={{paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap',marginBottom: '0px'}}>参&#12288;数：</label>
                        <div style={{position: 'relative'}}>
                            <input type="text" readonly="readonly" spellcheck="false" placeholder={a.paramDescription} id="jobsinput10001" className="form-control" style={{padding: '2px', height: '22px', width: '180px', fontSize: '12px'}}/>
                        </div>
                    </div>
                </div>
              )
            }
            {type === "LIST" && (
                <div style={{paddingTop:'20px'}}>
                    <h6 style={{textAlign:'center',fontWeight:'bolder'}}>{a.jobDescription}</h6>
                    <div id="JobsEditor10000" className="editorGroup" style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                        <label for="jobsinput10000" className="fieldGroupLabel" style={{paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap',marginBottom: '0px'}}>返回值：  </label>
                        <div style={{position: 'relative'}}>
                            <input type="text" spellcheck="false" placeholder={a.returnDescription} id="jobsinput10000" className="form-control" style={{padding: '2px', height: '22px', width: '180px', fontSize: '12px'}}/>
                        </div>
                    </div>
                    <div id="JobsEditor10001" className="editorGroup" style={{display: 'flex', flexDirection: 'row', alignItems: 'center',paddingTop:'5px'}}>
                        <label for="jobsinput10001" className="fieldGroupLabel" style={{paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap',marginBottom: '0px'}}>参&#12288;数：</label>
                        <div style={{position: 'relative'}}>
                            <input type="text" readonly="readonly" spellcheck="false" placeholder={a.paramDescription} id="jobsinput10001" className="form-control" style={{padding: '2px', height: '22px', width: '180px', fontSize: '12px'}}/>
                        </div>
                    </div>
                </div>
            )} 
            {type === "MAP" && (
                <div style={{paddingTop:'20px'}}>
                    <h6 style={{textAlign:'center',fontWeight:'bolder'}}>{a.jobDescription}</h6>
                    <div id="JobsEditor10000" className="editorGroup" style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                        <label for="jobsinput10000" className="fieldGroupLabel" style={{paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap',marginBottom: '0px'}}>返回值：  </label>
                        <div style={{position: 'relative'}}>
                            <input type="text" spellcheck="false" placeholder={a.returnDescription} id="jobsinput10000" className="form-control" style={{padding: '2px', height: '22px', width: '180px', fontSize: '12px'}}/>
                        </div>
                    </div>
                    <div id="JobsEditor10001" className="editorGroup" style={{display: 'flex', flexDirection: 'row', alignItems: 'center',paddingTop:'5px'}}>
                        <label for="jobsinput10001" className="fieldGroupLabel" style={{paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap',marginBottom: '0px'}}>参&#12288;数：</label>
                        <div style={{position: 'relative'}}>
                            <input type="text" readonly="readonly" spellcheck="false" placeholder={a.paramDescription} id="jobsinput10001" className="form-control" style={{padding: '2px', height: '22px', width: '180px', fontSize: '12px'}}/>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/jobs/TabFromItem.js